import React from 'react';
import { AskingBidValue } from 'components/project/FloorBidderScreen';
import styled from 'styled-components';

const AskingBidContainer = () => (
  <Container>
    <AskingBidValue showCurrencySymbol={false} />
  </Container>
);

export default AskingBidContainer;

const Container = styled.div`
  grid-area: askingBid;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  & h1 {
    white-space: nowrap;
    margin: 0;
    color: #fff;
    font-size: min(18vw, 19em);
  }
`;